import { NeedForSweepDataPoints } from "./NeedForSweepDataPoints";
import { useMemo } from "react";
import { DateTime } from "luxon";
import { ChartDataProviderProProps } from "@mui/x-charts-premium";

export const useDataset = (
  dataPoints: NeedForSweepDataPoints,
  startDate?: DateTime<true>
): ChartDataProviderProProps["dataset"] => {
  return useMemo(() => {
    if (startDate === undefined) {
      return dataPoints as unknown as ChartDataProviderProProps["dataset"];
    }
    return dataPoints.between(
      startDate
    ) as unknown as ChartDataProviderProProps["dataset"];
  }, [dataPoints, startDate]);
};
